import {useMemo} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {jwtDecode} from 'jwt-decode';
import _ from 'lodash';

/**
 * The current user's own client id from the Keycloak JWT
 * (otto_identity.client.id), or null when the token is missing, unreadable or
 * carries no client. Mirrors the customer-management hook of the same name.
 */
const useOwnClientId = (): string | null => {
    const {keycloak} = useKeycloak();

    return useMemo(() => {
        if (!keycloak?.token) return null;
        try {
            const decoded = jwtDecode<Record<string, unknown>>(keycloak.token);
            const clientId = _.get(decoded, 'otto_identity.client.id', null);
            return clientId !== null && clientId !== undefined ? String(clientId) : null;
        } catch {
            return null;
        }
    }, [keycloak?.token]);
};

export default useOwnClientId;
